function show_collection_description() {
  document.querySelectorAll(".collection_description_btn").forEach((button) => {
    if (button.dataset.collectionDescriptionBound === "true") return;

    button.dataset.collectionDescriptionBound = "true";
    button.addEventListener("click", () => {
      const isActive = button.classList.toggle("active");
      button.textContent = isActive ? "See Less >" : "Read More >";

      document.querySelectorAll(".collection_description-container .collection_description").forEach((description) => {
        description.style.display = getComputedStyle(description).display === "none" ? "block" : "none";
      });
    });
  });

  document.querySelectorAll(".collectionOtherContent .show-more-text").forEach(bindShowMoreText);
}

function bindShowMoreText(button) {
  if (button.dataset.collectionShowMoreBound === "true") return;

  button.dataset.collectionShowMoreBound = "true";
  button.addEventListener("click", () => toggleShowMoreText(button));
}

function toggleShowMoreText(button) {
  const isActive = button.classList.toggle("active");
  button.textContent = isActive ? "See Less >" : "Read More >";
  button.previousElementSibling?.classList.toggle("active", isActive);
}

function show_product_item_image() {
  if (document.documentElement.dataset.collectionSwatchImagesBound === "true") return;

  document.documentElement.dataset.collectionSwatchImagesBound = "true";
  document.addEventListener("click", (event) => {
    const colorSwatch = event.target.closest(".product-list__inner .color-swatch");
    if (!colorSwatch) return;

    const productItem = colorSwatch.closest(".product-item");
    if (!productItem) return;

    const primaryImage = productItem.querySelector(".product-item__primary-image");
    const secondaryImage = productItem.querySelector(".product-item__secondary-image");
    const featuredMedia = colorSwatch.getAttribute("data-img");
    const nextImage = colorSwatch.getAttribute("next-img");

    productItem.classList.add("hideVideo");

    if (primaryImage && featuredMedia) {
      primaryImage.src = featuredMedia;
      primaryImage.alt = colorSwatch.getAttribute("data-alt") || "";
      primaryImage.removeAttribute("srcset");
    }

    if (secondaryImage && nextImage) {
      secondaryImage.src = nextImage;
      secondaryImage.alt = colorSwatch.getAttribute("next-alt") || "";
      secondaryImage.removeAttribute("srcset");
    }
  });
}

function color_mouseleave_filter() {
  document.querySelectorAll(".color-list-item").forEach((item) => {
    if (item.dataset.collectionColorItemBound === "true") return;

    item.dataset.collectionColorItemBound = "true";
    item.addEventListener("click", () => {
      window.setTimeout(() => {
        item.classList.toggle("active");
        const parent = item.closest(".color-item");
        parent?.classList.toggle("hascolor", parent.querySelectorAll(".color-list-item.active").length > 0);
      }, 10);
    });
  });
}

function getUrlParameters(parameter) {
  return new URLSearchParams(window.location.search).getAll(parameter);
}

function bindColorSwatchClick() {
  const colorValues = getUrlParameters("filter.v.option.color");

  window.setTimeout(() => {
    const selectedColors = new Set(colorValues);

    colorValues.forEach((colorValue) => {
      document.querySelectorAll(".product-item-meta__swatch-list .color-swatch").forEach((swatch) => {
        if (swatch.getAttribute("data-colortip") === colorValue) swatch.click();
      });
    });

    document.querySelectorAll(".color-list-item").forEach((item) => {
      item.classList.toggle("active", selectedColors.has(item.dataset.label));
    });

    if (colorValues.length > 0 && typeof window.show_product_item_image === "function") {
      window.show_product_item_image();
    }
  }, 20);
}

function checkActiveItems() {
  window.setTimeout(() => {
    document.querySelectorAll(".color-item").forEach((item) => {
      item.classList.toggle("hascolor", item.querySelectorAll(".color-list-item.active").length > 0);
    });

    document.querySelectorAll(".color-list-all").forEach((allButton) => {
      const items = allButton.nextElementSibling?.querySelectorAll(".color-list-item") || [];
      allButton.classList.toggle("on", Array.from(items).every((item) => item.classList.contains("active")));
    });
  }, 30);
}

function setColorImageSize(item, size) {
  const image = item.querySelector(".color-img-box span");
  if (!image) return;

  image.style.width = `${size}px`;
  image.style.height = `${size}px`;
}

function positionColorList(item, listBox) {
  const colorItems = Array.from(item.parentElement?.children || []).filter((child) => child.classList.contains("color-item"));
  const index = colorItems.indexOf(item);

  if (index < 2) {
    listBox.style.left = "0";
    listBox.style.right = "auto";
    listBox.style.transform = "translateX(0)";
  } else if (index >= colorItems.length - 2) {
    listBox.style.left = "auto";
    listBox.style.right = "0";
    listBox.style.transform = "translateX(0)";
  } else {
    listBox.style.left = "50%";
    listBox.style.right = "";
    listBox.style.transform = "translateX(-50%)";
  }
}

function closeColorItem(item) {
  const listBox = item.querySelector(".color-list-box");
  if (listBox) listBox.style.display = "none";

  item.classList.remove("color-list-active");
  setColorImageSize(item, 50);

  const siblings = Array.from(item.parentElement?.children || []).filter((child) => child.classList.contains("color-item"));
  const index = siblings.indexOf(item);
  [siblings[index - 1], siblings[index + 1]].filter(Boolean).forEach((sibling) => setColorImageSize(sibling, 50));
}

function openColorItem(item) {
  document.querySelectorAll(".color-item").forEach((otherItem) => {
    if (otherItem === item) return;
    const listBox = otherItem.querySelector(".color-list-box");
    if (listBox) listBox.style.display = "none";
    otherItem.classList.remove("color-list-active");
    setColorImageSize(otherItem, 50);
  });

  const listBox = item.querySelector(".color-list-box");
  if (listBox) {
    listBox.style.display = "block";
    positionColorList(item, listBox);
  }

  item.classList.add("color-list-active");
  setColorImageSize(item, 60);

  const siblings = Array.from(item.parentElement?.children || []).filter((child) => child.classList.contains("color-item"));
  const index = siblings.indexOf(item);
  [siblings[index - 1], siblings[index + 1]].filter(Boolean).forEach((sibling) => setColorImageSize(sibling, 55));
}

function initializeColorFilter() {
  const colorFilter = document.querySelector(".color_filter");
  if (!colorFilter) return;

  if (typeof window.Swiper === "function" && colorFilter.dataset.swiperInitialized !== "true") {
    colorFilter.dataset.swiperInitialized = "true";
    new window.Swiper(".color_filter", {
      slidesPerView: 12,
      paginationClickable: true,
      freeMode: true,
      scrollbar: ".swiper-scrollbar",
      breakpoints: {
        1600: { slidesPerView: 12 },
        1200: { slidesPerView: 10 },
        999: { slidesPerView: 9 },
        740: { slidesPerView: 8 },
        540: { slidesPerView: 6 },
        300: { slidesPerView: 5 }
      }
    });
  } else {
    const slides = Array.from(colorFilter.querySelectorAll(".color-item.swiper-slide"));
    const track = colorFilter.querySelector(".color-link-box");
    let nativeOffset = 0;
    let pointerId;
    let pointerStartX = 0;
    let pointerStartOffset = 0;
    let pointerMoved = false;
    let suppressNextClick = false;

    const updateNativeTrackPosition = () => {
      if (!track) return;

      const maxOffset = Math.max(0, track.scrollWidth - colorFilter.clientWidth);
      nativeOffset = Math.min(Math.max(nativeOffset, 0), maxOffset);
      track.style.transform = `translate3d(${-nativeOffset}px, 0, 0)`;
    };

    if (track && track.dataset.nativeDragBound !== "true") {
      track.dataset.nativeDragBound = "true";

      colorFilter.addEventListener("pointerdown", (event) => {
        if (!colorFilter.classList.contains("color-filter-native") || (event.pointerType === "mouse" && event.button !== 0)) return;

        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartOffset = nativeOffset;
        pointerMoved = false;
        colorFilter.setPointerCapture?.(pointerId);
      });

      colorFilter.addEventListener("pointermove", (event) => {
        if (event.pointerId !== pointerId) return;

        const distance = pointerStartX - event.clientX;
        if (!pointerMoved && Math.abs(distance) < 6) return;

        pointerMoved = true;
        nativeOffset = pointerStartOffset + distance;
        updateNativeTrackPosition();
        event.preventDefault();
      }, { passive: false });

      const finishNativeDrag = (event) => {
        if (event.pointerId !== pointerId) return;

        if (pointerMoved) {
          suppressNextClick = true;
          window.setTimeout(() => { suppressNextClick = false; }, 0);
        }

        colorFilter.releasePointerCapture?.(pointerId);
        pointerId = undefined;
      };

      colorFilter.addEventListener("pointerup", finishNativeDrag);
      colorFilter.addEventListener("pointercancel", finishNativeDrag);
      colorFilter.addEventListener("click", (event) => {
        if (!suppressNextClick) return;

        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    const setNativeSlideWidths = () => {
      const viewportWidth = window.innerWidth;
      let slidesPerView = 5;

      if (viewportWidth >= 1600) slidesPerView = 12;
      else if (viewportWidth >= 1200) slidesPerView = 10;
      else if (viewportWidth >= 999) slidesPerView = 9;
      else if (viewportWidth >= 740) slidesPerView = 8;
      else if (viewportWidth >= 540) slidesPerView = 6;

      const slideWidth = 100 / slidesPerView;
      const itemWidth = 100 / slides.length;
      const trackWidth = Math.max(100, slides.length * slideWidth);
      colorFilter.classList.toggle("color-filter-native", slides.length > slidesPerView);

      if (track) {
        track.style.display = "flex";
        track.style.justifyContent = "flex-start";
        track.style.width = `${trackWidth}%`;
        track.style.minWidth = "100%";
      }

      slides.forEach((item) => {
        item.style.width = `${itemWidth}%`;
        item.style.flexBasis = `${itemWidth}%`;
        item.style.flexGrow = "0";
        item.style.flexShrink = "0";
      });

      updateNativeTrackPosition();
    };

    setNativeSlideWidths();
    let resizeFrame;
    window.addEventListener("resize", () => {
      if (resizeFrame) return;

      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = undefined;
        setNativeSlideWidths();
      });
    }, { passive: true });
  }

  document.querySelectorAll(".color-list-item").forEach((item) => {
    const label = item.dataset.label;
    const swatch = Array.from(document.querySelectorAll(".product-facet__filter-item .color-swatch__radio")).find((radio) => radio.value === label);

    if (!swatch) {
      item.remove();
      return;
    }

    item.htmlFor = swatch.id;
  });

  document.querySelectorAll(".color_filter .color-item").forEach((item) => {
    if (item.querySelectorAll(".color-list-item").length > 0) return;

    item.querySelector(".color-list-box")?.remove();
    item.classList.add("no-child");
  });

  const mobile = window.innerWidth <= 999;
  document.querySelectorAll(".color-item").forEach((item) => {
    const eventName = mobile ? "click" : "mouseenter";
    item.addEventListener(eventName, () => {
      if (mobile && item.classList.contains("color-list-active")) {
        closeColorItem(item);
      } else {
        openColorItem(item);
      }
    });

    if (!mobile) item.addEventListener("mouseleave", () => closeColorItem(item));
  });

  const title = document.querySelector(".collection__title__h1 h1")?.textContent.trim();
  if (title === "Green Dresses") {
    document.querySelectorAll(".color-img-box").forEach((image) => {
      image.addEventListener("click", () => image.closest(".color-item")?.querySelector(".color-list-all")?.click());
    });
  }

  document.querySelectorAll(".color-list-all").forEach((allButton) => {
    allButton.addEventListener("click", () => {
      allButton.nextElementSibling?.querySelectorAll(".color-list-item").forEach((item) => item.click());
    });
  });
}

function initializeCollectionPage() {
  if (window.location.pathname === "/collections/evening-dresses") {
    window.location.href = "/collections/evening-dresses-gowns";
    return;
  }

  show_collection_description();
  show_product_item_image();

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".collectionFaqText .show-more-text");
    if (button) toggleShowMoreText(button);
  });

  document.querySelectorAll(".collectionFaqBox").forEach((box) => {
    box.innerHTML = box.innerHTML.replace(/2023|2024/g, "2025");
  });

  document.querySelectorAll(".collectionNewsList").forEach((list) => {
    list.style.display = list.querySelectorAll(".item").length === 0 ? "none" : "";
  });

  document.querySelectorAll(".product-facet__product-list .product-item").forEach((product) => {
    const image = product.querySelector(".product-item__primary-image");
    const swatchList = product.querySelector(".color-swatch-list--mini");
    const colorMatch = image?.alt.trim().match(/#color_([\w\s&-]+)/i);
    if (!colorMatch || !swatchList) return;

    const currentColor = colorMatch[1].toLowerCase();
    const radios = swatchList.querySelectorAll(".color-swatch__radio");
    let matched = false;

    radios.forEach((radio) => {
      const swatchColor = radio.parentElement?.querySelector(".color-swatch__item")?.dataset.color?.toLowerCase();
      radio.checked = swatchColor === currentColor;
      matched ||= radio.checked;
    });

    // The collection can use a collection-specific image which has no matching
    // variant swatch. Leaving all swatches unchecked is more accurate than
    // falsely marking the first color as selected.
  });

  initializeColorFilter();
  color_mouseleave_filter();
  bindColorSwatchClick();
  checkActiveItems();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeCollectionPage);
} else {
  initializeCollectionPage();
}
